import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import supabase from '../utils/supabaseUtils';
import { getOrCreateAppUser } from '../utils/supabaseUtils';
import { recordLogin } from '../utils/loginTracker';
import {
  Box,
  Container,
  Heading,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  Center,
  Image
} from '@chakra-ui/react';
import playmakerLogo from '../assets/playmaker-logo.png';

const VerifyAuth = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your login link...');

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const code = new URLSearchParams(window.location.search).get("code");
        if (code) {
          const { data, error } = await supabase.auth.exchangeCodeForSession(code);
          if (!error) {
            await getOrCreateAppUser();
            await recordLogin(data.session.user.id);
            navigate("/dashboard", { replace: true });
          } else {
            setStatus("error");
            setMessage(error.message);
          }
        }
      } catch (error) {
        console.error('Error during token verification:', error);
        setStatus('error');
        setMessage('An unexpected error occurred. Please try again.');
      }
    };

    verifyToken();
  }, [navigate]);

  return (
    <Box bg="bg.primary" minH="100vh" py={12} px={4}>
      <Container maxW="md" bg="white" p={8} borderRadius="lg" boxShadow="sm" borderWidth="1px" borderColor="neutral.300">
        <Center flexDirection="column" h="300px">
          <Image 
            src={playmakerLogo} 
            alt="PlayMaker Pics" 
            maxW="200px" 
            mb={6}
          />
          
          <Heading as="h1" size="lg" mb={6} textAlign="center" color="brand.500">
            {status === 'verifying' ? 'Verifying Your Login' : 
             status === 'success' ? 'Login Successful' : 'Login Failed'}
          </Heading>
          
          {status === 'verifying' && (
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.500"
              size="xl"
              mb={4}
            />
          )}
          
          <Alert 
            status={status === 'verifying' ? 'info' : 
                  status === 'success' ? 'success' : 'error'} 
            borderRadius="md"
          >
            <AlertIcon />
            {message}
          </Alert>
        </Center>
      </Container>
    </Box>
  );
};

export default VerifyAuth; 